import {forwardRef, startTransition} from 'react'
import {ComboboxProvider, ComboboxProviderProps, DialogProps, DialogStoreProps, useDialogStore} from '@ariakit/react'
import {StyledCommandMenuDialog, StyledCommandMenuOverlay} from './style'

export interface CommandMenuProps extends DialogProps {
    open?: DialogStoreProps['open']
    onOpenChange?: DialogStoreProps['setOpen']
    onSearch?: ComboboxProviderProps['setValue']
}

export const CommandMenu = forwardRef<HTMLDivElement, CommandMenuProps>(
    ({open, onOpenChange, onSearch, ...props}, ref) => {
        const dialog = useDialogStore({open, setOpen: onOpenChange})

        return (
            <StyledCommandMenuDialog
                ref={ref}
                unmountOnHide
                backdrop={<StyledCommandMenuOverlay />}
                {...props}
                store={dialog}
            >
                <ComboboxProvider
                    disclosure={dialog}
                    focusLoop={false}
                    includesBaseElement={false}
                    resetValueOnHide
                    setValue={value => startTransition(() => onSearch?.(value))}
                >
                    {props.children}
                </ComboboxProvider>
            </StyledCommandMenuDialog>
        )
    }
)
